import type { ShareTrackData } from '../types';

export const ShareTrackApi = Symbol('ShareTrackApi');

export interface ShareTrackApi {
    trackShare(dataTrack: ShareTrackData): Promise<boolean>;
}
